import React, { useEffect, useState } from 'react';
import { reportProps } from './StopLossAggregateTable';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import { CostTrend } from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { Grid } from '@mui/material';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import { radioLegend } from '../pages/StopLossAggregateReportPage';
import { getXaxisLabels } from '../core-utils/helper-utils/utilizattionProcedureHelper';

export interface PaidClaimsTrendProps {
  isMedical?: boolean;
}
type CombinedProps = reportProps & PaidClaimsTrendProps;
const PaidClaimsTrend: React.FC<CombinedProps> = ({ data, isMedical }) => {
  const [medClaimsTrend, setMedClaimsTrend] = useState<any>([]);
  const [xAxisLabels, setXAxisLabels] = useState<any>([]);

  const getPaidClaimsTrend = async () => {
    const currentYearcostTrend = data?.paidClaimsTrend;
    const medClaimsTrend = {
      currentMedicalTotalPaid: currentYearcostTrend?.costTrend
        ?.filter((item: any) =>
          isMedical
            ? item?.claim_type === 'medical'
            : item?.claim_type === 'rx',
        )
        ?.map((item: any) => {
          return { value: item?.total_cost };
        }),
    };

    const noOfMedClaimsTrendMonth =
      medClaimsTrend.currentMedicalTotalPaid.length;

    const xAxisValues: { label: string }[] = [];
    let currentMonth = currentYearcostTrend?.startFromMonth;
    let currentYear = currentYearcostTrend?.startFromYear;

    for (let i = 0; i < noOfMedClaimsTrendMonth; i++) {
      xAxisValues.push({ label: getXaxisLabels(currentMonth, currentYear) });

      // Move to the next month
      currentMonth += 1;

      // If the month rolls over to January (13), reset to 1 and increment the year
      if (currentMonth > 12) {
        currentMonth = 1;
        currentYear += 1;
      }
    }

    const medDataSetProp = [
      {
        seriesname: 'Current Year Trend',
        plottooltext: 'Current Year Trend - $$dataValue',
        data: medClaimsTrend?.currentMedicalTotalPaid,
        color: patientAccessTheme.palette.AIQChips?.legend1,
        renderas: 'line',
        anchorBgColor: patientAccessTheme.palette.AIQChips?.legend1,
      },
    ];
    setMedClaimsTrend(medDataSetProp);
    setXAxisLabels(xAxisValues);
  };

  useEffect(() => {
    getPaidClaimsTrend();
  }, []);
  return (
    <div style={{ width: '80%' }}>
      <CostTrend
        chartTitle={
          (isMedical ? 'Medical' : 'Pharmacy') + ' Plan Paid Cost Trend'
        }
        chartSubTitle={`Shows distribution of ${
          isMedical ? 'Medical' : 'Pharmacy'
        } Cost for Current Year and Previous Year`}
        showClickHere={false}
        datasetProp={medClaimsTrend}
        xAxisValues={xAxisLabels}
        customYAxisTitle={
          <Grid style={{ position: 'absolute', top: '80px', left: '35px' }}>
            <Typography
              fontSize="12px"
              lineHeight="23px"
              textColor={patientAccessTheme.palette.text.mediumemphasis}
            >
              Cost($)
            </Typography>
          </Grid>
        }
        chartType={'msline'}
        showLegend="0"
        yAxisTitle=""
        cardWidth="98%"
        cardHeight=""
        chartContainerStyles={{ width: '100%', height: '310px' }}
        chartWidth="97%"
        spaceBetweenTitleAndChart="2rem"
        customLegend={
          <Grid
            container
            style={{
              position: 'absolute',
              bottom: '5px',
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            {medClaimsTrend.map((item: any) =>
              radioLegend(item?.color, item?.seriesname),
            )}
          </Grid>
        }
      />
    </div>
  );
};
export default PaidClaimsTrend;
